import React, { useState } from "react";
import { Button, CardContent, Grid, Card } from "@mui/material";

import "react-tabulator/lib/styles.css"; // required styles
import "tabulator-tables/dist/css/tabulator.min.css"; // theme
import { ReactTabulator, reactFormatter } from "react-tabulator";
import { DeleteOutline, Edit } from "@mui/icons-material";

import FacilityGroupMapModal from "../../../services/FacilityGroupMapModal";
import FacilityGroupMapEditModal from "services/FacilityGroupMapEditModal";

import { useQuery, useMutation } from "@tanstack/react-query";
import * as api from "../../../actions/api";
import { useTranslation } from "react-i18next";
const lan = localStorage.getItem("LangCode");
const AssignGroup = ({ ...props }) => {
  const { t } = useTranslation();
  const permissionType = props.permissionType;
  const [SupplyFromData, setDataItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [FacilityServiceId, setFacilityServiceId] = useState(0);
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const menukey = "facility";
  const [GroupList, setGroupList] = useState([]);

  //////////////////////////////

  const columns = [
    { title: "FacilityServiceId", field: "FacilityServiceId", visible: false },
    {
      title: t(DispensingLanguage[lan][menukey]["Sl#"]),
      hozAlign: "center",
      width: 70,
      formatter: "rownum",
      headerHozAlign: "center",
      headerSort: false,
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Product Group"]),
      headerFilter: true,
      field: "GroupName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Start Month"]),
      headerFilter: true,
      field: "MonthName",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Start Year"]),
      headerFilter: true,
      field: "StartYearId",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Supply From"]),
      headerFilter: true,
      field: "Supplier",
    },
    {
      title: t(DispensingLanguage[lan][menukey]["Action"]),
      field: "custom",
      hozAlign: "center",
      width: 60,
      headerSort: false,
      headerHozAlign: "center",
      formatter: reactFormatter(<ActionButton />),
      frozen: true,
    },
  ];

  const [StockDataItems, setStockDataItems] = useState([]);

  let params = {
    menukey: menukey,
    action: "getStockRecortdWithItemGrouplist",
    FacilityId: props.match.params.id,
    page_limit: JSON.stringify(100),
    page_number: JSON.stringify(0 + 1),
    search_key: "",
  };

  const { isLoading, error, isError, data, refetch } = useQuery(
    [params],
    api.getStockRecortdWithItemGroup,
    {
      onSuccess: (stockdata) => {
        setStockDataItems(stockdata);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );

  function ActionButton(props: any) {
    const rowData = props.cell._cell.row.data;
    // console.log(rowData);
    const rowItemGroupId = rowData.ItemGroupId.toString(); // Convert to string

    const cellValue = props.cell._cell.value || "Edit | Show";

    /*  console.log('xxxxxxxxx StockDataItems:', StockDataItems);
    console.log('xxxxxxxxx rowItemGroupId:', rowItemGroupId);
    console.log('xxxxxxxxx rowData:', rowData); */

    let isDeleteVisible = true;

    for (const item of StockDataItems) {
      if (item.ItemGroupId.toString() === rowItemGroupId) {
        // Convert to string for comparison
        isDeleteVisible = false;
        break;
      }
    }

    if (permissionType) return <></>;
    else
      return (
        <>
          <Edit
            onClick={() => {
              setFacilityServiceId({
                FacilityServiceId: rowData.FacilityServiceId,
                SupplyFrom: rowData.SupplyFrom,
                MonthName: rowData.MonthName,
                StartYearId: rowData.StartYearId,
                GroupName: rowData.GroupName,
              });

              handleClose("openEditModal");
              //editFacility(rowData);
            }}
          />
          {isDeleteVisible && (
            <DeleteOutline
              onClick={() => {
                deleteApi({ FacilityServiceId: rowData.FacilityServiceId });
              }}
            />
          )}
        </>
      );

    /*  return (
      <>
        <Edit
          onClick={() => {
            setFacilityServiceId({
              FacilityServiceId:rowData.FacilityServiceId,
              SupplyFrom:rowData.SupplyFrom,
              MonthName:rowData.MonthName,
              StartYearId:rowData.StartYearId,
              GroupName:rowData.GroupName
            });
            
            handleClose('openEditModal');
            //editFacility(rowData);
          }}
        />

        <DeleteOutline
          onClick={() => {
            deleteApi({FacilityServiceId:rowData.FacilityServiceId}); 
          }}
        />
        
      </>
    ); */
  }
  const handleClose = (modalname) => {
    switch (modalname) {
      case "Products":
        groupmaprefetch();
        setOpen(false);
        break;
      case "ProductsOpen":
        //  groupmaprefetch();
        let fDtat = { lan: lan, FacilityId: props.match.params.id };
        getProductGroupMapPopup(fDtat);

        break;
      case "openEditModal":
        //   getProductGroupMapPopup({"lan":lan,  FacilityId:props.match.params.id});
        setOpenEditModal(true);
        break;

      case "closeEditModal":
        setOpenEditModal(false);
        groupmaprefetch();
        break;

      default:
        break;
    }
  };

  const { mutate: getProductGroupMapPopup } = useMutation(
    api.getProductGroupMapPopup,
    {
      onSuccess: (data) => {
        if (data.data.status == 200) {
          setGroupList(data.data.datalist);

          /* if(SupplyFromData && SupplyFromData.length) {
          const ItemGroupId = SupplyFromData[0].ItemGroupId;
          const filteredGroupList = data.data.datalist.filter((group) => group.id !== parseInt(ItemGroupId));
          setGroupList(filteredGroupList);
        }else{
          setGroupList(data.data.datalist);
        } */
        } else {
        }
      },
    }
  );

  const { refetch: groupmaprefetch } = useQuery(
    [{ FacilityId: props.match.params.id }],
    api.getFacilityGroupMap,
    {
      onSuccess: (data) => {
        setDataItems(data);
      },
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: 0, //1000 * 60 * 60 * 24,
    }
  );
  const { mutate: deleteApi } = useMutation(api.deleteFacilityGroupMap, {
    onSuccess: (data) => {
      if (data.data.status == 200) {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
        groupmaprefetch();
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.data.message,
          msgtype: data.data.success,
        });
      }
    },
  });

  React.useEffect(() => {
    if (GroupList.length > 0) setOpen(true);
  }, [GroupList]);

  return (
    <div>
      {/* start of filter */}
      <Card className="sw_card sw_filter_card">
        <CardContent className="sw_filterCardContent">
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <div className="float-end sw_btn_control">
                <Button
                  disabled={!!props.permissionType}
                  className="me-2"
                  variant="contained"
                  color="primary"
                  onClick={() => handleClose("ProductsOpen")}
                >
                  {DispensingLanguage[lan][menukey]["Assign groups"]}
                </Button>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      {/* end of filter */}
      <div className="sw_relative">
        <div className="uniqueName">
          <ReactTabulator
            columns={columns}
            data={SupplyFromData}
            height={300}
            layout={"fitColumns"}
          />
        </div>
      </div>

      <FacilityGroupMapModal
        handleClose={handleClose}
        open={open}
        GroupList={GroupList}
        {...props}
      />

      <FacilityGroupMapEditModal
        handleClose={handleClose}
        open={openEditModal}
        FacilityServiceId={FacilityServiceId}
        {...props}
      />
    </div>
  );
};
export default AssignGroup;
